import { Box } from "@mui/material";

const TransformEditor = (node: any, index: number) => {
  const url = node.attribs?.url;
  const classNode = node.attribs?.class;
  if (node.name === "oembed" && url) {
    // Replace YouTube URL with a responsive embed iframe
    if (url.includes("youtu")) {
      return (
        <Box
          sx={{
            position: "relative",
            width: "100%",
            paddingTop: "56.25%", // Aspect ratio: 16:9
            minHeight: "350px",
          }}
        >
          <iframe
            src={url.replace("youtu.be", "www.youtube.com/embed")}
            title="YouTube video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
          />
        </Box>
      );
    }
  }
  if (node.name === "figure") {
    const children = node.children as any[];
    if (!children) return <></>;
    //only image
    if (classNode === "image") {
      return (
        <Box
          sx={{
            display: "flex",
            width: "100%",
            marginTop: "20px",
          }}
        >
          {children.map((itemChild, index) => {
            return (
              <Box
                key={index}
                component="img"
                src={itemChild.attribs?.src}
                alt={""}
                style={{
                  width: "100%",
                  height: "100%",
                }}
              />
            );
          })}
        </Box>
      );
    }
    //Image loat left and right
    if (classNode === "image image-style-align-left") {
      const childrenRight = node.next.children as any[];
      if (!childrenRight) return <></>;
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            marginTop: "20px",
          }}
        >
          {children.map((itemChild, index) => {
            return (
              <Box
                key={index}
                component="img"
                src={itemChild.attribs?.src}
                alt={""}
                style={{
                  width: "49%",
                  height: "auto",
                  marginRight: "5px",
                }}
              />
            );
          })}

          {childrenRight.map((itemChild, index) => {
            return (
              <Box
                key={index}
                component="img"
                src={itemChild.attribs?.src}
                alt={""}
                style={{
                  width: "49%",
                  height: "auto",
                  marginLeft: "5px",
                }}
              />
            );
          })}
        </Box>
      );
    }
    if (classNode === "image image-style-align-right") return <></>;
  }

  if (node.name === "p") {
    const children = node.children as any[];
    if (!children) return <></>;
    const arrImageChild = children.filter((x) => x.name === "img");
    if (arrImageChild.length > 0) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            marginTop: "20px",
          }}
        >
          {arrImageChild.map((itemChild, index) => {
            return (
              <Box
                key={index}
                component="img"
                src={itemChild.attribs?.src}
                alt={""}
                style={{
                  width: `${100 / arrImageChild.length}%`,
                  height: "auto",
                  marginRight: "5px",
                }}
              />
            );
          })}
        </Box>
      );
    }
  }
};
export default TransformEditor;
